
import { fetch } from 'whatwg-fetch';

const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const BACKEND_LOGGEND_IN_STORAGE = 'backendLoggedIn';
const LOGIN_API_URL = '/api/adminportal/authentication/LogIn';
const LOGOUT_API_URL = '/api/adminportal/authentication/LogOut';

const ARTICLE_API_URL = '/api/adminportal/article';

const GET_PAGES_API_URL = '/api/adminportal/article/pages';
const CREATE_PAGE_API_URL = '/api/adminportal/article/CreatePage';
const LANDING_PAGE_API_URL = '/api/adminportal/article/LandingPage';

const EMPLOYEE_API_URL = '/api/adminportal/employee';

const GET_BLOCKS = '/api/adminportal/settings/Blocks';
const LOCAL_CAMPAIGN_BLOCK_API_URL = '/api/adminportal/settings/LocalCampaignBlock';
const SETTINGS_API_URL = '/api/adminportal/settings';
export const BACKEND_LOGGEND_IN_SHOPID = 'backendShopId';
export const BACKEND_LOGGEND_IN_ONLYECOM = 'backendShopOnlyEcom';
export const BACKEND_LOGGEND_IN_ECOMADMIN = 'backendShopEcomAdmin';
export const BACKEND_LOGGEND_IN_SHOPNAME = 'backendShopName';


export const isLoggedInCheck = () => {
    return !!localStorage.getItem(BACKEND_LOGGEND_IN_STORAGE);
}

export const isOnlyEcomCheck = () => {
    return localStorage.getItem(BACKEND_LOGGEND_IN_ONLYECOM) === "true";
}

export const isEcomAdmin = () => {
    return localStorage.getItem(BACKEND_LOGGEND_IN_ECOMADMIN) === "true";
}

export const backendStoreName = () => {
    return localStorage.getItem(BACKEND_LOGGEND_IN_SHOPNAME);
}

export const logout = () => {
    post(LOGOUT_API_URL)
        .then(result => {
            if (result.status == 200) {
                localStorage.removeItem(BACKEND_LOGGEND_IN_STORAGE);
                localStorage.removeItem(BACKEND_LOGGEND_IN_SHOPID);
                localStorage.removeItem(BACKEND_LOGGEND_IN_ONLYECOM);
                localStorage.removeItem(BACKEND_LOGGEND_IN_ECOMADMIN);
                localStorage.removeItem(BACKEND_LOGGEND_IN_SHOPNAME);
                location.reload();
            }
        });
};

export const login = (email, password) => {    
    let encodedPassword = encodeURIComponent(password);       

    post(encodeURI(`${LOGIN_API_URL}`), null, null, `${email}:${encodedPassword}`)
        .then(response => response.json())
        .then(result => {
            if (result && result.id) {
                localStorage.setItem(BACKEND_LOGGEND_IN_SHOPID, result.relatedToShop[0].shopid);
                localStorage.setItem(BACKEND_LOGGEND_IN_STORAGE, true);
                localStorage.setItem(BACKEND_LOGGEND_IN_ONLYECOM, result.isOnlyEcommerceAccess);
                localStorage.setItem(BACKEND_LOGGEND_IN_ECOMADMIN, result.isEcomAdmin);
                localStorage.setItem(BACKEND_LOGGEND_IN_SHOPNAME, result.storeName);
                location.reload();
            }
        });
};

export const getArticles = () => {
    return get(ARTICLE_API_URL)
        .then(response => response.json());
};

export const getArticle = (id) => {
    return get(`${ARTICLE_API_URL}/${id}`)
        .then(response => response.json());
};

export const updatePage = (data) => {
    const form_data = new FormData();

    for (const key in data) {
        form_data.append(capitalizeFirstLetter(key), data[key]);
    }

    return post(`${LANDING_PAGE_API_URL}`, form_data).then(response => response.json());
}

export const updateArticle = (guid, data) => {
    const form_data = new FormData();

    for (const key in data) {
        form_data.append(capitalizeFirstLetter(key), data[key]);
    }


    if (guid != null) {
        form_data.append("Id", guid);
    }

    if (form_data.get('ArticleImage')) {
        form_data.delete('ImageId');
    }

    return post(`${ARTICLE_API_URL}`, form_data).then(response => response.json());
}

export const getPages = () => {
    return get(GET_PAGES_API_URL)
        .then(response => response.json());
};

export const getPage = (id) => {
    return get(`${LANDING_PAGE_API_URL}?landingPageGuid=${id}`)
        .then(response => response.json());
};


export const updateLocalCampaignBlock = (_) => {
    return put(LOCAL_CAMPAIGN_BLOCK_API_URL)
        .then(response => response.json());
};

export const createPage = () => {
    return post(`${CREATE_PAGE_API_URL}?template=StoreWebsitePage&pageName=StoreWebsitePage`)
        .then(response => response.json());
};

export const deletePages = (data) => {
    return deleteRequest(`${ARTICLE_API_URL}/${data}`)
        .then(response => response);
};

export const deleteEmployee = (data) => {
    return deleteRequest(`${EMPLOYEE_API_URL}/${data}`)
        .then(response => response);
};


export const getBlock = (blockId) => {
    return get(`${LOCAL_CAMPAIGN_BLOCK_API_URL}/${blockId}`)
        .then(response => response.json());
};

export const getBlocks = (pageId) => {
    return get(`${GET_BLOCKS}?pageId=${pageId}`)
        .then(response => response.json());
};


export const getEmployees = () => {
    return get(EMPLOYEE_API_URL)
        .then(response => response.json());
};

export const getEmployee = (id) => {    
    return get(`${EMPLOYEE_API_URL}/${id}`)
        .then(response => response.json());
};

export const updateEmployee = (guid, data) => {

    const form_data = new FormData();
    for (const key in data) {
        form_data.append(capitalizeFirstLetter(key), data[key]);
    }
    if (form_data.get('EmployeeImage')) {
        form_data.delete('ImageId');
    }

    if (!!guid) {
        form_data.append("Id", guid);
    }

    return post(`${EMPLOYEE_API_URL}`, form_data, { 'content-type': 'multipart/form-data' }).then(response => response);
};

export const getSettings = () => {
    return get(SETTINGS_API_URL)
        .then(response => response.json());
};

export const updateSettings = (data, localCampaignDescription, pricingData) => {
    const form_data = new FormData();

    for (const key in data) {
        if (key === "localCampaignDescription") {
            form_data.append(capitalizeFirstLetter(key), localCampaignDescription);
        }else if (key === "pricingDetails") {
            form_data.append(capitalizeFirstLetter(key), pricingData);
        }
         else {
            form_data.append(capitalizeFirstLetter(key), data[key]);
        }        
    }        

    return put(`${SETTINGS_API_URL}`, form_data, { 'content-type': 'multipart/form-data' }).then(response => response);
};

export const get = (url, abortController = null) => _fetch(url, "GET", null, abortController);
export const deleteRequest = (url, abortController = null) => _fetch(url, "DELETE", null, abortController);
export const put = (url, data, abortController = null) => _fetch(url, "PUT", data, abortController);
export const post = (url, data, abortController = null, loginCredentials = null) => _fetch(url, "POST", data, abortController, loginCredentials);

const _fetch = (url, method, data = null, abortController = null, loginCredentials = null) => {
    let options = loginCredentials !== null ? {
        method,
        headers: {
            'litium-request-context': JSON.stringify(window.__litium.requestContext),
            "Authorization": "Basic " + btoa(loginCredentials)
        },
        credentials: 'include',
    } :  {
        method,
        headers: {
            'litium-request-context': JSON.stringify(window.__litium.requestContext),        
        },
        credentials: 'include',
    };
    if (abortController) {
        options.signal = abortController.signal;
    }
    if (method !== "GET") {
        let body;
        let headers;
        if (data instanceof FormData) {
            headers = {
                ...options.headers
            };
            body = data;
        } else {
            headers = {
                ...options.headers,
                'content-type': 'application/json',
            }
            body = data ? JSON.stringify(data) : null;
        }
        options = {
            ...options,
            body,
            headers
        };
    }
    // use native browser implementation if it supports aborting
    const abortableFetch = ('signal' in new Request('')) ? window.fetch : fetch;
    return abortableFetch(url, options)
        .then(_checkStatus);
};

const _checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        if (response.status === 401) {
            logout();
        }

        let error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
};